'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('../SvgIcon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortUp = function SortUp(props) {
	return _react2.default.createElement(
		_SvgIcon.SvgIcon,
		_extends({ viewBox: '0 0 26 26' }, props),
		_react2.default.createElement('path', { d: 'M22.727 18c.453 0 1.062-.3 1.214-.75.154-.45 0-.898-.303-1.352C20.293 11.102 13.91 6.3 13.91 6.3s-.3-.3-.906-.3c-.613 0-.914.3-.914.3S5.707 11.103 2.363 15.9c-.304.454-.457.903-.304 1.352.15.45.76.75 1.213.75z' })
	);
};

exports.default = SortUp;